module.exports = __webpack_public_path__ + "img/broadnet_bsp.b1e5d44d.png";